import ReactDOM from 'react-dom/client';
import App from './app/components/App';

const container = document.querySelector('#glossary-overview');

if (!container) throw new Error('Glossary container not found');

const root = ReactDOM.createRoot(container);
const observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			root.render(<App dataUrl={container.getAttribute('data-rest-url') || ''} />);
			observer.unobserve(container);
		}
	});
});

observer.observe(container);
